import { Injectable } from '@angular/core';
import * as jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

const CSV_TYPE = 'data:text/csv;charset=utf-8,';
const CSV_EXTENSION = '.csv';

@Injectable({
  providedIn: 'root'
})
export class ReportExportAsService {

  constructor() { }

  print() {
    const h1 = document.createElement('h1');
    h1.innerText = 'Hilocals Reporting system';
    const divToPrint = document.getElementById('report');
    divToPrint.insertAdjacentElement('afterbegin', h1);
    divToPrint.querySelectorAll('.no-print').forEach(node => node.remove());
    const newWindow = window.open('');
    newWindow.document.write(divToPrint.outerHTML);
    newWindow.print();
    newWindow.close();
    divToPrint.removeChild(h1);
  }

  csv(dataArray: Array<any>, fileName) {
    let csvContent = '';
    csvContent += CSV_TYPE;

    csvContent += this.objectToCSVRow(Object.keys(dataArray[0]));
    dataArray.forEach((item) => {
      csvContent += this.objectToCSVRow(item);
    });

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', fileName + '_report_' + new Date().getTime() + CSV_EXTENSION);

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  private objectToCSVRow(dataObject) {
    const dataArray = new Array();
    for (const o in dataObject) {
      if (o) {
        const innerValue = dataObject[o] === null ? '' : dataObject[o].toString();
        let result = innerValue.replace(/"/g, '""');
        result = '"' + result + '"';
        dataArray.push(result);
      }
    }
    return dataArray.join(',') + '\r\n';
  }

  pdf(dataArray: Array<any>) {
    const doc = new jsPDF('landscape');
    const columns = Object.keys(dataArray[0]);
    const rows = dataArray.map(object => {
      const row = [];
      for (const i of Object.keys(object)) {
        row.push(object[i]);
      }
      return row;
    });
    doc.autoTable({
      head: [columns],
      body: rows
    });

    doc.save('Ashranda_report.pdf');
  }

  xlsx(dataArray: Array<any>, fileName) {
    const workSheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataArray);
    const workBook: XLSX.WorkBook = {
      Sheets: {
        data: workSheet
      },
      SheetNames: ['data']
    };
    const excelBuffer: any = XLSX.write(workBook, {
      bookType: 'xlsx',
      type: 'array'
    });
    this.saveAsExcel(excelBuffer, fileName);
  }

  private saveAsExcel(buffer: any, filename: string) {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, filename + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }
}
